(function () {
  var body = document.body;
  var header = document.querySelector('[data-header]');
  var drawer = document.querySelector('[data-mobile-drawer]');
  var openDrawer = document.querySelector('[data-open-drawer]');
  var closeDrawer = document.querySelector('[data-close-drawer]');
  var drawerOverlay = document.querySelector('[data-drawer-overlay]');

  function setHeaderState() {
    if (!header) return;
    header.classList.toggle('is-scrolled', window.scrollY > 16);
  }

  function showDrawer() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    body.classList.add('drawer-open');
    drawer.removeAttribute('aria-hidden');
  }

  function hideDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    body.classList.remove('drawer-open');
    drawer.setAttribute('aria-hidden', 'true');
  }

  if (openDrawer) openDrawer.addEventListener('click', showDrawer);
  if (closeDrawer) closeDrawer.addEventListener('click', hideDrawer);
  if (drawerOverlay) drawerOverlay.addEventListener('click', hideDrawer);

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') hideDrawer();
  });

  setHeaderState();
  window.addEventListener('scroll', setHeaderState, { passive: true });

  var revealItems = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window && revealItems.length) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.14 });

    revealItems.forEach(function (item) {
      observer.observe(item);
    });
  } else {
    revealItems.forEach(function (item) {
      item.classList.add('is-visible');
    });
  }

  document.querySelectorAll('.quantity').forEach(function (quantity) {
    var input = quantity.querySelector('input');
    var minus = quantity.querySelector('[data-quantity-minus]');
    var plus = quantity.querySelector('[data-quantity-plus]');

    if (!input) return;

    if (minus) {
      minus.addEventListener('click', function () {
        var min = Number(input.getAttribute('min') || 0);
        input.value = Math.max(min, Number(input.value || 0) - 1);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }

    if (plus) {
      plus.addEventListener('click', function () {
        input.value = Number(input.value || 0) + 1;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }
  });

  document.querySelectorAll('[data-product-root]').forEach(function (root) {
    var json = root.querySelector('[data-product-variants]');
    var idInput = root.querySelector('[name="id"]');
    var price = root.querySelector('[data-product-price]');
    var addButton = root.querySelector('[data-add-to-cart]');
    var stickyButton = document.querySelector('[data-sticky-add]');
    var variants = [];

    if (!json || !idInput) return;

    try {
      variants = JSON.parse(json.textContent);
    } catch (error) {
      return;
    }

    function getSelectedOptions() {
      var selected = [];
      root.querySelectorAll('[data-option-index]').forEach(function (fieldset) {
        var optionIndex = Number(fieldset.getAttribute('data-option-index'));
        var checked = fieldset.querySelector('input:checked');
        selected[optionIndex] = checked ? checked.value : null;
      });
      return selected;
    }

    function formatMoney(cents) {
      if (window.Shopify && Shopify.formatMoney) {
        return Shopify.formatMoney(cents);
      }
      return (cents / 100).toLocaleString(undefined, {
        style: 'currency',
        currency: 'EGP'
      });
    }

    function updateVariant() {
      var selected = getSelectedOptions();
      var variant = variants.find(function (item) {
        return item.options.every(function (option, index) {
          return option === selected[index];
        });
      });

      if (!variant) {
        if (addButton) {
          addButton.disabled = true;
          addButton.textContent = root.getAttribute('data-unavailable-text');
        }
        return;
      }

      idInput.value = variant.id;
      if (price) {
        price.textContent = formatMoney(variant.price);
      }
      if (addButton) {
        addButton.disabled = !variant.available;
        addButton.textContent = variant.available ? root.getAttribute('data-add-text') : root.getAttribute('data-sold-out-text');
      }
      if (stickyButton) {
        stickyButton.disabled = !variant.available;
      }
    }

    root.querySelectorAll('[data-option-index] input').forEach(function (input) {
      input.addEventListener('change', updateVariant);
    });

    updateVariant();
  });

  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    form.addEventListener('submit', function (event) {
      if (!window.fetch || !form.action || form.method.toLowerCase() !== 'post') return;
      if (!form.closest('[data-product-card]')) return;

      event.preventDefault();
      var formData = new FormData(form);
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: formData
      }).then(function () {
        return fetch('/cart.js', { headers: { Accept: 'application/json' } });
      }).then(function (response) {
        return response.json();
      }).then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (count) {
          count.textContent = cart.item_count;
          count.classList.add('is-updated');
          window.setTimeout(function () {
            count.classList.remove('is-updated');
          }, 420);
        });
      }).catch(function () {
        form.submit();
      });
    });
  });

  document.querySelectorAll('[data-sticky-add]').forEach(function (button) {
    button.addEventListener('click', function () {
      var addButton = document.querySelector('.product-form button[type="submit"]');
      if (addButton) addButton.click();
    });
  });
})();
